module.exports = __webpack_public_path__ + "static/media/numerology.90b6005d.jpeg";